import {
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
} from "@/components/elements/HoverCard";
import Tooltip from "@/components/elements/Tooltip";
import { IntegrationLogoBox, useIntegration } from "@/integrations";

import { DataSource } from "../columns";

export function SourceCell(props: { row: DataSource }) {
  return (
    <div className="flex items-center space-x-2">
      <IntegrationLogoBox id={props.row.sourceIntegrationId} size="xs" />
      <div className="whitespace-nowrap">
        <MainLabel row={props.row} />
      </div>
    </div>
  );
}

const MainLabel = (props: { row: DataSource }) => {
  const integrationId = props.row.sourceIntegrationId;
  const integration = useIntegration(integrationId);
  const tooltip = `${props.row.sourceConnection?.label || integrationId} (${integration?.name})`;
  if (
    ["google-sheets", "google-sheets-service-account", "ftp"].includes(
      integrationId,
    )
  ) {
    const displayableTables = (props.row.sourceStreams ?? []).filter(
      (elem) => elem != null,
    );

    if (displayableTables.length > 0) {
      const tableNames = displayableTables.map((x) => x.name);
      return (
        <HoverCard openDelay={100} closeDelay={100}>
          <HoverCardTrigger tabIndex={0} asChild>
            <span>
              <span>{props.row.sourceConnection?.label || integrationId}</span>
              <span className="text-muted-foreground">
                <span className="px-1">-</span>
                <span>{formatTables(tableNames)}</span>
              </span>
            </span>
          </HoverCardTrigger>
          <HoverCardPortal>
            <HoverCardContent side="top" className="w-80 p-3 text-sm">
              <div className="mb-2 text-muted-foreground">{tooltip}</div>
              <div className="mb-1 font-medium">
                {displayableTables.length}{" "}
                {displayableTables.length === 1 ? "Table" : "Tables"}
              </div>
              <ul className="my-1 ml-1 list-inside list-disc text-muted-foreground">
                {displayableTables.map((stream) => (
                  <li key={stream.name}>{stream.name}</li>
                ))}
              </ul>
            </HoverCardContent>
          </HoverCardPortal>
        </HoverCard>
      );
    }
  }

  return (
    <Tooltip content={tooltip}>
      <div>{props.row.sourceConnection?.label || integrationId}</div>
    </Tooltip>
  );
};

const formatTables = (tables: string[]) => {
  if (tables.length === 0) {
    return "";
  }

  const truncate = (str: string, n: number) => {
    if (n <= 3) {
      return str.substring(0, n);
    }
    if (str.length <= n) {
      return str;
    }
    return str.substring(0, n - 3) + "...";
  };

  if (tables.length === 1) {
    return truncate(tables[0] ?? "", 25);
  }
  const truncatedTablesList = truncate(tables.join(", "), 25);
  return `(${tables.length}) ${truncatedTablesList}`;
};
